module.exports = __webpack_public_path__ + "static/img/companyBase.2debef28.svg";